module.exports = __webpack_public_path__ + "media/images/landing/browser_mobile.es-acfe36fb09e953316eedc2edc4cc02d5.png";